import _ from 'lodash';
import { lifecycle, compose, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import API from 'utils/api';
import { setProperty } from 'utils/state';
import { checkPermission } from 'utils/credentials';
import { ROLES } from 'consts';
import AgencyCodeList from '../components/AgencyCodeList';

const $lifecycle = lifecycle({
  componentDidMount() {
    this._isMounted = true;
    this.props.setMounted(() => () => this._isMounted, this.props.updateItems);
  },

  componentDidUpdate() {
    checkPermission(this, ROLES.AGENCY);
  },

  componentWillUnmount() {
    this._isMounted = false;
  },
});

const mapStateToProps = state => {
  return {
    roles: _.get(state, 'auth.currentGroup.myRoles', 'default'),
    setProperty,
  };
};

const enhance = compose(
  connect(mapStateToProps),

  withState('items', 'setItems', []),
  withState('count', 'setCount', 0),
  withState('page', 'setPage', 0),
  withState('pageSize', 'setPageSize', 10),
  withState('sort', 'setSort', { field: 'fullName', direction: 'asc' }),
  withState('mounted', 'setMounted', () => () => {}),

  withHandlers({
    updateItems: props => () => {
      API.getAgencyCodes({
        page: props.page + 1,
        pageSize: props.pageSize,
        sort: `${props.sort.direction === 'desc' ? '-' : ''}${
          props.sort.field
        }`,
      }).then(data => {
        if (data && data.docs) {
          setProperty(props, 'items', data.docs);
          setProperty(props, 'count', data.total);
        }
      });
    },
  }),
  withHandlers({
    activePauseCode: props => referralId => {
      API.activePauseAgencyCode(referralId).then(data => {
        if (data && data.status === 201) {
          props.updateItems();
        }
      });
    },
  }),
  withHandlers({
    onChangePage: props => (_event, page) =>
      setProperty(props, 'page', page, props.updateItems),

    onChangeRowsPerPage: props => event =>
      setProperty(props, 'pageSize', event.target.value, props.updateItems),
  }),

  $lifecycle
);

export default enhance(AgencyCodeList);
